import FaqsCont from "../containers/faqs/faqs";

const Faqs = () => {
    return <FaqsCont />;
};

export default Faqs;
